import React from "react";
import { LoadingSpinner } from "../LoadingSpinner";
import * as styles from "./styles";

export interface ButtonProps {
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  variant?: "contained" | "outlined" | "text";
  size?: "small" | "medium" | "large";
  startAdornment?: JSX.Element;
  isLoading?: boolean;
  type?: "button" | "submit";
  children: React.ReactNode;
  props?: { [key: string]: string };
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      disabled = false,
      onClick,
      variant = "contained",
      startAdornment,
      size = "medium",
      type = "button",
      isLoading,
      props,
    },
    ref,
  ) => {
    const handleClick = (
      e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => {
      if (disabled) return;
      if (!onClick) return;
      if (isLoading) return;

      onClick(e);
    };

    return (
      <button
        data-variant={variant}
        data-size={size}
        onClick={handleClick}
        disabled={disabled || isLoading}
        className={styles.button}
        type={type}
        ref={ref}
        {...props}
      >
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            {startAdornment && (
              <div className={styles.iconContainer}>{startAdornment}</div>
            )}
            {children}
          </>
        )}
      </button>
    );
  },
);

Button.displayName = "Button";
